import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const LeadCapture = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !phone) return;
    setIsSubmitting(true);
    try {
      await api.post('/leads/submit', { name, email, phone });
      setSubmitted(true);
      setTimeout(() => navigate('/register'), 2000);
    } catch (e) { alert(e.response?.data?.message || 'Failed'); }
    finally { setIsSubmitting(false); }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-5">
        <div className="w-full max-w-[450px] text-center">
          <div className="bg-white border-2 border-[#e2e8f0] rounded-2xl p-10 shadow-lg">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#7c3aed] via-[#8b5cf6] to-[#6366f1] flex items-center justify-center mx-auto mb-5">
              <i className="fas fa-check-circle text-white text-3xl" />
            </div>
            <h2 className="text-2xl font-extrabold text-[#0f172a] tracking-[-0.5px] mb-2">THANK YOU!</h2>
            <p className="text-[#475569] text-sm font-bold mb-2">Your details have been submitted successfully</p>
            <p className="text-[#64748b] text-xs font-mono">Redirecting to registration page...</p>
            <div className="mt-6 flex justify-center">
              <div className="w-10 h-10 border-[3px] border-[#8b5cf6] border-t-transparent rounded-full animate-spin" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-5">
      <div className="w-full max-w-[450px]">
        {/* Logo/Brand */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#7c3aed] via-[#8b5cf6] to-[#6366f1] flex items-center justify-center mx-auto mb-4 shadow-lg shadow-[#8b5cf6]/20">
            <span className="text-3xl font-extrabold text-white">A</span>
          </div>
          <h2 className="text-2xl font-extrabold text-[#0f172a] tracking-[-0.5px] mb-1">
            Anzo <span className="bg-gradient-to-br from-[#7c3aed] via-[#8b5cf6] to-[#6366f1] bg-clip-text text-transparent">Trade</span>
          </h2>
          <p className="text-[#64748b] text-xs font-mono font-bold uppercase tracking-wider">Enter your details to begin trading</p>
        </div>

        {/* Form Card */}
        <div className="bg-white border-2 border-[#e2e8f0] rounded-2xl p-8 shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Full Name */}
            <div>
              <label className="text-[10px] text-[#5b21b6] font-mono font-extrabold uppercase tracking-wider block mb-2">
                <i className="fas fa-user mr-1.5 text-[#8b5cf6]" />
                FULL NAME
              </label>
              <input 
                type="text" 
                value={name} 
                onChange={e => setName(e.target.value)} 
                placeholder="John Doe" 
                className="w-full bg-[#f8fafc] border-2 border-[#cbd5e1] rounded-xl px-4 py-3 text-[#0f172a] text-sm font-extrabold outline-none focus:border-[#8b5cf6] transition-all placeholder:text-[#94a3b8]" 
                required 
              />
            </div>

            {/* Email Address */}
            <div>
              <label className="text-[10px] text-[#5b21b6] font-mono font-extrabold uppercase tracking-wider block mb-2">
                <i className="fas fa-envelope mr-1.5 text-[#8b5cf6]" />
                EMAIL ADDRESS
              </label>
              <input 
                type="email" 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                placeholder="you@example.com" 
                className="w-full bg-[#f8fafc] border-2 border-[#cbd5e1] rounded-xl px-4 py-3 text-[#0f172a] text-sm font-extrabold outline-none focus:border-[#8b5cf6] transition-all placeholder:text-[#94a3b8]" 
                required 
              />
            </div>

            {/* Phone Number */}
            <div>
              <label className="text-[10px] text-[#5b21b6] font-mono font-extrabold uppercase tracking-wider block mb-2">
                <i className="fas fa-phone-alt mr-1.5 text-[#8b5cf6]" />
                PHONE NUMBER
              </label>
              <input 
                type="tel" 
                value={phone} 
                onChange={e => setPhone(e.target.value)} 
                placeholder="+1234567890" 
                className="w-full bg-[#f8fafc] border-2 border-[#cbd5e1] rounded-xl px-4 py-3 text-[#0f172a] text-sm font-extrabold outline-none focus:border-[#8b5cf6] transition-all placeholder:text-[#94a3b8]" 
                required 
              />
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              disabled={isSubmitting} 
              className="w-full py-3.5 rounded-xl bg-gradient-to-br from-[#7c3aed] via-[#8b5cf6] to-[#6366f1] text-white font-extrabold text-sm uppercase tracking-wider hover:bg-[#7c3aed] disabled:opacity-50 transition-all border-b-[3px] border-[#7c3aed] flex items-center justify-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  <span>SUBMITTING...</span>
                </>
              ) : (
                <>
                  <i className="fas fa-rocket" />
                  <span>START TRADING NOW</span>
                </>
              )}
            </button>

            {/* Divider */}
            <div className="flex items-center gap-3">
              <div className="flex-1 h-0.5 bg-[#e2e8f0]" />
              <span className="text-[9px] text-[#94a3b8] font-mono font-extrabold uppercase">OR</span>
              <div className="flex-1 h-0.5 bg-[#e2e8f0]" />
            </div>

            {/* Sign In Link */}
            <p className="text-center text-[11px] text-[#64748b] font-mono font-bold">
              Already have an account?{' '}
              <a href="/login" className="text-[#8b5cf6] font-extrabold hover:underline uppercase">
                SIGN IN
              </a>
            </p>
          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-[9px] text-[#94a3b8] font-mono mt-6 uppercase tracking-wider">
          SECURE & ENCRYPTED CONNECTION
        </p>
      </div>
    </div>
  );
};

export default LeadCapture;